exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nbody{margin:0;padding:0\n}\n.content{width:100%;height:100%\n}\n", "", {"version":3,"sources":["D:/地质云项目/DZYWebUI/src/layout/default.vue"],"names":[],"mappings":";AACA,KAAK,SAAS,SAAS;CACtB;AACD,SAAS,WAAW,WAAW;CAC9B","file":"default.vue","sourcesContent":["\nbody{margin:0;padding:0\n}\n.content{width:100%;height:100%\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16a445c4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/default.vue
// module id = t413
// module chunks = 78